export const transactionOnboardingData: any = {
  id: '-1',
  vehicle: {
    number_plate: 'LWTK43',
    latest_transaction: {
      id: 191,
      reservation_id: null,
      id_tag_start: '9CF6DD918055',
      id_tag_stop: null,
      meter_start: 85199352,
      meter_stop: 85204999,
      timestamp_start: '2022-02-08T07:31:19.257000',
      timestamp_stop: '2022-02-08T07:37:21.105000',
      reason_stop: 'Local',
      soc_start: 99,
      soc_stop: 100,
      cost: 513,
      price: 1185,
      max_power: '130217.00',
      avg_power: '48154.08',
      total_energy: 5647,
      soh: null,
      odometer: null,
      remaining_time: null,
      connector: 15,
      user_start: null,
      user_stop: null,
      vehicle: 'LWTK43',
    },
    verbose_name: '769',
    vin: '9CF6DD918055',
    vin2: null,
    brand: 'King Long',
    model: 'XMQ 6127',
    class_type: 'Bus',
    nominal_range: 0,
    consumption: 0,
    battery_nominal_capacity: null,
    co2eqIC: 0,
    vin_as_id_tag: true,
    latest_soc: null,
    latest_odometer: null,
    latest_remaing_km: null,
    latest_temperature: null,
    status: 'Offline',
    fleet: 3,
    latest_tracker_log: null,
  },
  user_start: null,
  user_stop: null,
  reservation_id: null,
  id_tag_start: '9CF6DD918055',
  id_tag_stop: null,
  meter_start: 85199352,
  meter_stop: 85204999,
  timestamp_start: '2022-02-08T07:31:19.257000',
  timestamp_stop: '2022-02-08T07:37:21.105000',
  reason_stop: 'Local',
  soc_start: 99,
  soc_stop: 100,
  cost: 513,
  price: 1185,
  max_power: '130217.00',
  avg_power: '48154.08',
  total_energy: 5647,
  soh: null,
  odometer: null,
  remaining_time: null,
  created: '2022-02-08T07:31:21.411366',
  updated: '2022-05-05T21:38:03.533153',
  connector: -2,
};
